import { useLearningPathQuery } from '@/modules/corporate/modules/path/graphql/queries/generated/learningPath';
import {
  addIsOptionalInContentData,
  getOptionalContentInPathMap,
} from '@/modules/learner/views/LearnerProfile/components/LearnerContents/views/LearnerPathReport/utils';
import { PathContentType, ResourceStatusEnum } from '@/types/schema';
import { isValidObjectId } from '@/utils/urql';

interface Params {
  pathId: string;
  status?: ResourceStatusEnum;
}

const useLearningPath = ({ pathId, status }: Params) => {
  const [{ data, error, fetching }, refetchPath] = useLearningPathQuery({
    requestPolicy: 'cache-and-network',
    variables: {
      pathId,
      filters: {
        id: pathId,
        versionStatus: status,
      },
    },
    pause: !isValidObjectId(pathId),
  });
  const pathContent = data?.content as PathContentType | undefined;
  const allChildResourceConfigsMap = getOptionalContentInPathMap(pathContent);
  const adaptedPathSection = pathContent?.sections?.map((section) => {
    const childResources = section.childResources ?? [];
    const updatedChildResources = addIsOptionalInContentData(
      allChildResourceConfigsMap,
      childResources,
      'id',
    );
    section.childResources = updatedChildResources;
    return section;
  });
  if (pathContent?.sections) pathContent.sections = adaptedPathSection;
  return { fetching, error, path: pathContent, refetchPath };
};

export default useLearningPath;
